import React from "react";
import { RepInfo } from "./RepInfo";
import { TotalAssets } from "./TotalAssets";

export const Header = ({ viewer, clientNumber, setClientNumber, setPayPeriod, loading }) => {
	return (
		<div>
			<h1>COMPENSATION STATEMENTS</h1>
			<div className="row">
				<div className="col-lg-6">
					<RepInfo viewer={viewer} clientNumber={clientNumber} setClientNumber={setClientNumber} setPayPeriod={setPayPeriod} loading={loading}></RepInfo>
				</div>
				<div className="col-lg-6">
					<TotalAssets viewer={viewer} loading={loading}></TotalAssets>
				</div>
			</div>
		</div>
	);
};